/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { Module } from './module';

export type GenericApiResponseModuleData = Module | null;
